import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { setRecoil } from "recoil-nexus";
import ApiController from "../../controller/ApiController";
import {
  CALL_TYPE_SENDER,
  INTERPHONE_STATUS_SENDER_WAIT,
  InterphoneAreaType,
  SENDER_TYPE_ROOM,
} from "../../controller/InterphoneController";
import LogController from "../../controller/LogController";
import { InterphoneCardType } from "../../controller/MasterController";
import { useBackTimer } from "../../hooks/useBackTimer";
import { areaType } from "../../recoil/area";
import { interphoneState, InterphoneType } from "../../recoil/interphone";
import { langState } from "../../recoil/lang";
import { visibleCardState } from "../../recoil/modal";

export const useInterphoneList = () => {
  const queryClient = useQueryClient();
  const deviceArea = queryClient.getQueryData<areaType | undefined>([
    "device-area",
  ]);

  const navigate = useNavigate();
  const lang = useRecoilValue(langState);

  // 터치 제어 로직
  const { resetTimer } = useBackTimer("interphoneList");

  const [interphoneFlag, setInterphoneFlag] =
    useRecoilState<InterphoneType>(interphoneState);

  const [selectedCard, setSelectedCard] = useState<InterphoneCardType | null>(
    null
  );

  const requestVoiceChat = async (hotel_area_id: number) => {
    try {
      LogController.click({
        path: "InterphoneList",
        params: "interphone",
        params2: `${deviceArea?.area_id}에서 통화 연결 버튼 클릭`,
        index: hotel_area_id,
      });

      if (deviceArea) {
        const oParams = {
          room_area_id: deviceArea.area_id,
          hotel_area_id,
          sender: SENDER_TYPE_ROOM,
        };

        const response = await ApiController.interphone.requestVoiceChat(
          oParams
        );

        if (response && response.data) {
          const oRes = response.data;
          console.log("requestVoiceChat", oRes);
          if (oRes.data && oRes.data.false_reason === null) {
            setInterphoneFlag({
              ...interphoneFlag,
              type: CALL_TYPE_SENDER,
              interphone_call_manage_id: oRes.data.interphone_call_manage_id,
              room_name: oRes.data.room_name,
              status: INTERPHONE_STATUS_SENDER_WAIT,
            });
          } else {
            toast.error("현재 해당 구역은 통화중이에요");
          }
        }
      }
    } catch (err) {
      console.log("requestVoiceChat err-->", err);
    }
  };

  const openCard = (item: InterphoneAreaType) => {
    if (item.card_id && item.card_title) {
      setSelectedCard({ card_id: item.card_id, title: item.card_title });
    }
    setRecoil(visibleCardState, true);
    LogController.click({
      path: "interphoneList",
      params: "interphone",
      params2: `${item.card_title} 컨텐츠 오픈`,
      index: item.card_id || -1,
    });
  };

  const navigateMaster = () => {
    navigate("/master");
  };

  useEffect(() => {}, []);

  return {
    lang,
    selectedCard,
    requestVoiceChat,
    navigateMaster,
    openCard,
    resetTimer,
  };
};
